import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import BASE_URL from './config';

// Protected Route component that checks authentication and profile completion
function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState({
    isAuthenticated: null,
    profileComplete: false,
    isLoading: true
  });

  useEffect(() => {
    // Check if user is logged in and profile status
    fetch(`${BASE_URL}/check_login`, {
      method: 'GET',
      credentials: 'include'
    })
      .then(response => response.json())
      .then(data => {
        setAuthState({
          isAuthenticated: data.isLoggedIn,
          profileComplete: data.profileComplete || false,
          isLoading: false
        });
      })
      .catch(error => {
        setAuthState({
          isAuthenticated: false,
          profileComplete: false,
          isLoading: false
        });
      });
  }, []);

  // Show loading state while checking authentication
  if (authState.isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  // If not authenticated, redirect to home/login page
  if (!authState.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If authenticated but profile not complete, allow access to settings, rides, and feed
  // but redirect other pages to rides for onboarding
  if (authState.isAuthenticated && !authState.profileComplete) {
    const currentPath = window.location.pathname;
    if (currentPath === '/settings' || currentPath === '/rides' || currentPath === '/feed' || currentPath === '/newride' || currentPath === '/messages') {
      // Allow access to settings, rides, feed, and newride (they will show onboarding modal if needed)
      return children;
    } else {
      // Redirect other pages to rides for onboarding
      return <Navigate to="/rides" replace />;
    }
  }

  // If authenticated and profile complete, render the protected component
  return children;
}

export default ProtectedRoute;

